if (window.location.href.includes("importaciones")) {

    // Configuración de las opciones de la solicitud
    const requestOptions = {
        method: "GET",
        credentials: "include", // Incluye las cookies automáticamente
        headers: {
            "Content-Type": "application/json", // Si es necesario especificar un tipo de contenido
        },
        redirect: "follow",
    };

    const tableBody = document.querySelector("#ImpoTransito tbody");

    // Función para actualizar la tabla según los filtros
    function actualizarTabla(signal, { esRefrescoSilencioso = false } = {}) {
        const filtroImpo = document.getElementById("filtroImpo").value;
        const filtroBodega = document.getElementById("filtroBodega").value;
        const filtroEtapa = document.getElementById("filtroEtapa").value;

        if (!esRefrescoSilencioso) {
            window.mostrarFilasEsqueleto(tableBody, 7);
        }

        const params = new URLSearchParams({ filtroImpo, filtroBodega, filtroEtapa });
        const url = `/api/impo?${params.toString()}`;

        return fetch(url, { ...requestOptions, cache: "no-store", signal, sinCargando: true })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Error HTTP: ${response.status}`);
                }
                return response.json();
            })
            .then((result) => {
                // Limpiar la tabla antes de llenarla nuevamente
                tableBody.innerHTML = "";

                const jsonData = result;
                const imp = jsonData.result;

                imp.resultado.forEach((item) => {
                    const row = document.createElement("tr");
                    row.innerHTML = `
                        <td class="td-periodo">
                            <a class="a-table" href="/detalle-importacion?id-impo=${item.id_impo}">
                                ${item.nombre_impo}
                            </a>
                        </td>
                        <td>${item.etd}</td>
                        <td>${item.eta}</td>
                        <td>${item.ruta}</td>
                        <td>${item.bodega}</td>
                        <td>${item.destino}</td>
                        <td>${item.etapa}</td>
                    `;
                    tableBody.appendChild(row);
                });

                if (imp.num_registros === 0) {
                    const row = document.createElement("tr");
                    row.classList.add("no-data"); // Asignar la clase al <tr>
                    row.innerHTML = `
                        <td colspan="7">
                            <div class="cont-no-data">
                                No se encontró información.
                                <img class="icono-pequeño-gris" src="/public/build/img/icons/alerta.svg" alt="">
                            </div>
                        </td>
                    `;
                    tableBody.appendChild(row);
                }
            });
    }

    const actualizador = window.crearActualizadorApi(actualizarTabla);

    // Esperar una pausa corta antes de consultar con los nuevos filtros.
    document.getElementById("filtroImpo").addEventListener("input", actualizador.alCambiarFiltro);
    document.getElementById("filtroBodega").addEventListener("change", actualizador.alCambiarFiltro);
    document.getElementById("filtroEtapa").addEventListener("change", actualizador.alCambiarFiltro);

    // Limpiar filtros
    const btnLimpiarFiltros = document.getElementById("btnLimpiarFiltros");
    if (btnLimpiarFiltros) {
        btnLimpiarFiltros.addEventListener("click", () => {
            document.getElementById("filtroImpo").value = "";
            document.getElementById("filtroBodega").value = "0";
            document.getElementById("filtroEtapa").value = "0";
            actualizador.alCambiarFiltro();
        });
    }

    // Carga inicial inmediata y siguientes actualizaciones cada 5 minutos.
    actualizador.iniciar();
}
